module.exports = __webpack_public_path__ + "img/location-colored.38a3e328.svg";